<template>
    <div>
        <van-image
			style="width: 100vw"
			:src="mainImgUrlList"
		/>
        <van-form ref="vanForm" :model="item">
            <van-cell title="留言互动" size="large" is-link @click="gotoMessageBoardList">
                <template #right-icon>
                    <van-icon name="chat-o" :badge="badge" size="20"/>
                </template>
            </van-cell>
            <van-cell-group>
                <van-field
                        name="name"
                        v-model.trim="item.name"
                        clearable
                        label="姓名"
                        :rules="[{required: true, message: '请输入真实姓名'}]"
                />

                <van-field label="性别"
                           :rules="[{required: true, message: '请选择性别'}]">
                    <template #input>
                        <van-radio-group v-model="item.sex" direction="horizontal">
                            <van-radio name="M">男</van-radio>
                            <van-radio name="F">女</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field
                        name="phoneNo"
                        v-model.trim="item.phoneNo"
                        clearable
                        label="手机号码"
                        :rules="[{required: true, message: '请填写手机号码'}, {validator:validateMobile, message:'请输入正确的手机号'}]"
                />

                <van-field
                        name="email"
                        v-model.trim="item.email"
                        clearable
                        label="联系邮箱"
                        :rules="[{required: true, message: '请填写联系邮箱'}, {validator:validateEmail, message:'请输入正确的邮箱地址'}]"
                >
                </van-field>

                <van-field
                        name="title"
                        v-model="item.title"
                        rows="1"
                        autosize
                        label="主题"
                        type="textarea"
                        :rules="[{required: true, message: '请填写主题'}]"
                />

                <van-field
                        name="summary"
                        v-model="item.summary"
                        rows="2"
                        autosize
                        label="内容"
                        type="textarea"
                        maxlength="150"
                        show-word-limit
                        :rules="[{required: true, message: '请输入内容'}]"
                />

                <van-field
                        name="validateCode"
                        v-model="item.validateCode"
                        clearable
                        label="验证码"
                        :rules="[{required: true, message: '请填写图片验证码'}]">
                    <div slot="button">
                        <img :src="imageSrc" @click="refreshValidateCode"/>
                    </div>
                </van-field>

            </van-cell-group>
            <van-row type="flex" justify="center">
                <van-col span="22" style="text-align: center">
                    <van-button type="primary" @click="submitForm">提交</van-button>
                    <van-button type="danger" @click="resetForm">重置</van-button>
                </van-col>
            </van-row>
        </van-form>
    </div>
</template>

<script>
    import {isMobile} from 'vant/lib/utils/validate/mobile'
    import {isEmail} from 'vant/lib/utils/validate/email'
    import {insertMessageBoard, countMessageBoard} from '@/api/public/messageBoard'

    export default {
        name: 'MessageBoard',
        components: {
        },
        data() {
            return {
                smallLogo: require('@/assets/small-logo.png'),
                item: {},
                badge: 0,
                imageSrc: this.$APP_ROOT + "/api/weixin/leaveMessage/generateCode?t=" + new Date().getTime(),
                mainImgUrlList: require("@/assets/small-logo.png")
            }
        },
        mounted: function () {
            this.countMessageBoard();
        },
        methods: {
            validateMobile(value) {
                return isMobile(value);
            },
            validateEmail(value) {
                return isEmail(value);
            },
            countMessageBoard() {
                countMessageBoard().then((res) => {
                    this.badge = res.data;
                });
            },
            refreshValidateCode() {
                this.imageSrc = this.$APP_ROOT + "/api/weixin/leaveMessage/generateCode?t=" + new Date().getTime();
            },
            resetForm() {
                this.item = {}
            },
            submitForm() {
                this.$refs.vanForm.validate().then(() => {
                    insertMessageBoard(this.item).then(() => {
                        this.resetForm();
                        this.countMessageBoard();
                        this.$toast.success('留言创建成功...');
                    });
                }).catch(() => {
                    // this.$toast.fail('数据校验失败...');
                })
            },
            gotoMessageBoardList() {
                if (this.badge > 0) {
                    this.$router.push({
                        path: '/personal/messageBoardList', query: {
                            label: "留言板列表"
                        }
                    })
                } else {
                    this.$toast.fail('您没有留言信息....');
                    return;
                }
            }
        }
    }
</script>